import {Component, Prop, Watch} from 'vue-property-decorator';
import { Vue, Options } from 'vue-class-component'
import {CONFIG_ENV} from '@/config';
import {ServiceUser} from '@/services/ServiceUser';
import user from '@/store/user';
import nomenclatoare from '@/store/nomenclatoare';
import {getModule} from "vuex-module-decorators";
import {getNomenclatoare} from '@/modules/getNomenclatoare'
import {getFavorites} from "@/modules/getFavorites";
import {getBasket} from "@/modules/getBasket";
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import { ref } from 'vue';
import axios from 'axios';
import { ServiceDownload } from '@/services/ServiceDownload';
import VuePdfEmbed from 'vue-pdf-embed';

@Options({
    name: "Login",
    components: { VueHcaptcha, VuePdfEmbed },
})
export default class Login extends Vue {
    public password='';
    public confirmPassword='';
    public user='';
    public isPwd = true;
    public ajaxIsLoading = false;
    declare public $refs: any;
    public userStore = getModule(user);
    public storeNomenclatoare = getModule(nomenclatoare);
    public terms = false;
    public gdpr = false;
    public sitekey = process.env.VUE_APP_CAPTCHAKEY; 
    public downloadingFile = false;
    public pdfTitle='';
    public fixed=false;
    public pdf='';
    public myLocale=CONFIG_ENV.myLocale;
    public isLoadingDocument=false;
    public widthPdf=300;

    public changeWitdhPdf(op: string){
        if(op == 'in') {
            if(this.widthPdf > 1500) {return;}
            this.widthPdf *= 1.25; 
        } else {
            if(this.widthPdf < 300) {return;}
            this.widthPdf /= 1.25; 
        }
    }

    public focusOnPassword(){
        this.$refs.refPassword.focus();
    }
    public focusOnBtnLogin(){
        this.$refs.refBtnLogin.focus();
    }

    public onSubmit(){
        const vueInst=this;
        if(!vueInst.verified) {
            this.$q.notify({
                color: 'red',
                textColor: 'white',
                type: 'negative',
                icon: 'error',
                position: 'top',
                timeout: 1000,
                message: 'Captcha fara success, incercati din nou!'
            });
        } else {
            this.onSubmitLoginData();
        }
    }
    
    public onSubmitLoginData(){
        const vueInst=this;
        this.ajaxIsLoading=true;
        ServiceUser.loginUser(vueInst.user, vueInst.password).then(response=>{
            if(response.status=='success'){
                localStorage.setItem('isAuthenticatedUser', 'y');
                localStorage.setItem('userToken', response.user.userToken);
                localStorage.setItem('userId', response.user.userid);
                localStorage.setItem('userAppid', response.user.appid);
                vueInst.userStore.set_user(response.user);
                vueInst.userStore.set_user_is_authenticated(true);
                vueInst.storeNomenclatoare.set_loading_nomenclatoare(true);
                vueInst.gdpr = false;
                vueInst.terms = false;
                getNomenclatoare();
                getFavorites();
                getBasket();
                ServiceUser.getProfileImgAsString(vueInst.userStore.user.appid).then((response:any)=>{
                    localStorage.setItem('MyImgProfileString64', response.data);
                    vueInst.userStore.set_myimgprofilestring64(response.data);
                });
                vueInst.storeNomenclatoare.getNomenclatoare().then(response=>{
                    if(response=='success'){
                        vueInst.storeNomenclatoare.set_loading_nomenclatoare(false);
                        vueInst.$router.push({name: 'Dashboard'});
                    }
                });
            }
            vueInst.ajaxIsLoading=false;
        });
    }

    public verified = false;
    public expired = false;
    public token = "";
    public eKey = "";
    public error = "";
    public asyncExecuteHCaptcha = ref<VueHcaptcha|null>(null);
    
    public onVerify(tokenStr: string, ekey: string) {
        this.verified = true;
        this.token = tokenStr;
        this.eKey = ekey;
    }
    public onExpire() {
        console.log('Expired');
        this.verified = false;
        this.token = '';
        this.eKey = '';
        this.expired = true;
    }
    public onChallengeExpire() {
        console.log('Challenge expired');
        this.verified = false;
        this.token = '';
        this.eKey = '';
        this.expired = true;
    }
    public onError(err: string) {
        console.log(`Error: ${err}`);
        this.token = '';
        this.eKey = '';
        this.error = err;
    }
    async onAsyncExecute() {
        if (this.asyncExecuteHCaptcha.value) {
            const res = await this.asyncExecuteHCaptcha.value.executeAsync();
            console.log("Async execute response", res);
        }
    }

    async verifyHCaptchaResponse(responseToken: string, secretKey: string) {
        const url = 'https://hcaptcha.com/siteverify';
        const options = {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        };
        const params = new URLSearchParams();
        params.set('secret', secretKey);
        params.set('response', responseToken);
        try {
          const response = await axios.post(url, params, options);
          console.log(response);
          if(response.data.success == false) {
            this.$q.notify({
                color: 'red',
                textColor: 'white',
                type: 'negative',
                icon: 'error',
                position: 'top',
                timeout: 1000,
                message: 'Captcha fara success, incercati din nou!'
            });
          } else {
            this.onSubmitLoginData();
          }
          return response.data.success;
        } catch (err) {
            this.$q.notify({
                color: 'red',
                textColor: 'white',
                type: 'negative',
                icon: 'error',
                position: 'top',
                timeout: 1000,
                message: 'Captcha fara success, incercati din nou!'
            });
            console.error('Error verifying hCaptcha response:', err);
            return false;
        }
    }

    public downloadPDF() {
        const vueInst = this;
        const linkSource = vueInst.pdf;
        const downloadLink = document.createElement("a");
        const fileName = vueInst.pdfTitle + '.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    
    public generarePdfGDPR(type: string){
        const vueInst = this;
        vueInst.pdf = '';
        if(type == 'gdpr') {
            vueInst.pdfTitle = 'GDPR privacy policy';
        } else {
            vueInst.pdfTitle = 'Conditii generale de vanzare';
        }
        vueInst.isLoadingDocument= true;  
        vueInst.fixed = true;  
        ServiceDownload.generarePDFPrivacy(type).then(response => {
            vueInst.isLoadingDocument = false;
            if(response.status == 'success') {
                const pathPdf = response.message;
                vueInst.pdf = 'data:application/pdf;base64,'+ pathPdf;
            }
        });
        
    }
}
